import AndFilter from '../client/js/common/support/utils/druid/filters/AndFilter';
import InFilter from '../client/js/common/support/utils/druid/filters/InFilter';
import NotFilter from '../client/js/common/support/utils/druid/filters/NotFilter';
import type { Query } from '../client/js/main/types/druidTypes';

export class NativeQueriesService {
  convertFiltersToNativeDruidFilters(query: Partial<Query>): Partial<Query> {
    if (!query.filters || !Object.keys(query.filters).length) {
      return Object.assign({}, query, {
        filters: undefined,
        filter: query.filter,
      });
    }

    return Object.assign({}, query, {
      filters: undefined,
      filter: new AndFilter(
        // @ts-ignore
        Object.keys(query.filters).map((filterName) => {
          return this.convertToNativeFilter(filterName, query.filters![filterName]);
        })
      ),
    });
  }

  convertToNativeFilter(filterName: string, filterValues: string[]): NotFilter | InFilter | null {
    if (!filterName && !filterValues) {
      return null;
    }
    if (filterName.startsWith('!')) {
      return new NotFilter(new InFilter(filterName.substring(1), filterValues));
    } else {
      return new InFilter(filterName, filterValues);
    }
  }
}
